import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NavController } from '@ionic/angular';
import { finalize } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { ToastService } from '../_core/services/toast.service';
import { FeedbackService } from './feedback.service';

import { User } from '../_shared/models/user.model';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

@Component({
  standalone: false,
    selector: 'app-feedback',
    templateUrl: './feedback.page.html',
    styleUrls: ['./feedback.page.scss'],
})
export class FeedbackPage implements OnInit {
    public authService = inject(AuthService);

    form: UntypedFormGroup;
    formActive: boolean;
    isSending: boolean;

    constructor(
        private fb: UntypedFormBuilder,
        private toast: ToastService,
        private feedbackService: FeedbackService,
        private navController: NavController
    ) { }

    ngOnInit() {
        this.buildForm();
    }

    private async buildForm() {
        this.form = this.fb.group({
            description: ['', Validators.required],
            user: [this.authService.authUserSignal()?._id],
            appVersion: [await this.getAppVersion()],
            contactMethod: ['none'],
            email: ['']
        });

        this.form.get('contactMethod')
            .valueChanges
            .subscribe(
                value => {
                    const emailControl = this.form.get('email');
                    if (!emailControl) return;
                    
                    if (value === 'email') {
                        emailControl.setValidators([
                            Validators.required,
                            Validators.pattern('^[a-zA-Z0-9._-]+@[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]\\.[a-zA-Z]{2,}$')
                        ]);
                    } else {
                        emailControl.clearValidators();
                    }
                    emailControl.updateValueAndValidity();
                }
            );
        this.formActive = true;
    }

    submit() {
        if (this.form.valid) {
            this.isSending = true;
            this.feedbackService
                .create(this.form.value)
                .pipe(finalize(() => { this.isSending = false; }))
                .subscribe(
                    res => {
                        this.toast.presentToast(res.message);
                        this.navController.navigateBack('/');
                    },
                    err => {
                        //console.log(err)
                    }
                );
        } else {
            const contactMethod = this.form.get('contactMethod');
            const emailControl = this.form.get('email');
            const descriptionControl = this.form.get('description');
            
            if (contactMethod && contactMethod.value === 'email') {
                if (emailControl && emailControl.hasError('pattern')) {
                    this.toast.presentDangerToast(`There is a format error in your email address ${emailControl.value}`);
                } else if (!descriptionControl?.valid && !emailControl?.valid) {
                    this.toast.presentDangerToast('Description and email are required');
                } else if (!emailControl?.valid) {
                    this.toast.presentDangerToast('Email is required');
                } else if (!descriptionControl?.valid) {
                    this.toast.presentDangerToast('Description is required');
                }
            } else {
                this.toast.presentDangerToast('Description is required');
            }
        }
    }

    private async getAppVersion() {
        if (Capacitor.isNativePlatform()) {
            const info = await App.getInfo();
            return info.version;
        } else {
            return 'Browser';
        }
    }

}
